import { Provider } from 'react-redux';
import { mapReturnsStore, sagaMiddleware } from './MapReturnsStore';
import { PageComponent } from './components/PageComponent';
import { usePageMeta } from 'shared/mechanics/page-meta';
import { useEffect } from 'react';
import { rootSaga } from './sagas/root';

export const MapReturnsPage = () => {
	usePageMeta({
		title: 'Пульс рынка ETF онлайн',
		description: 'Рыночные изменения цен всех БПИФ на Московской Бирже в реальном времени',
		keyWords: ['heatmap', 'treemap', 'древовидная карта'],
		canonicalPath: 'map/returns' });

	useEffect(() => { sagaMiddleware.run(rootSaga) }, []);

	return (
		<Provider store={mapReturnsStore}>
			<PageComponent />
		</Provider>
	);
}